import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Why is my home insured for more than my assessment' },
	{
		name: 'description',
		content: 'Learn about homeowners insurance valuation',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/frequently-asked-questions/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				Frequently Asked Questions
			</Link>
			<br />
			<br />
			<h1 className="py-3 text-4xl font-black">
				Homeowners Insurance Valuation
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<strong>Why is my home insured for more than my assessment?</strong>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Home assessments are a statement of the real estate value of the
				property. If your insurance policy is a replacement cost valuation
				policy, then it should insure the amount it would cost to completely
				rebuild the structure from the ground up in the event of a total loss.
			</p>
		</main>
	)
}
